import { z } from 'zod';
/**
 * Structured metadata returned alongside LLM text for rich rendering.
 * All fields optional — the response degrades gracefully to plain text.
 */
export const StrongsRefSchema = z.object({
    number: z.string(),
    native: z.string().optional(),
    pronunciation: z.string().optional(),
    shortDefinition: z.string().optional(),
    language: z.enum(['Hebrew', 'Greek']).optional(),
});
export const VerseRefSchema = z.object({
    reference: z.string(),
    text: z.string().optional(),
});
export const CrossRefSchema = z.object({
    from: z.string(),
    to: z.string(),
    toText: z.string().optional(),
    votes: z.number().optional(),
    source: z.enum(['cross-ref', 'commentary']).optional(),
});
export const NotableStrongsRefSchema = StrongsRefSchema.extend({
    word: z.string(),
    frequency: z.number(),
});
export const ValidationWarningSchema = z.object({
    code: z.enum([
        'verse-not-found',
        'strongs-testament-mismatch',
        'ungrounded-attribution',
    ]),
    message: z.string(),
    detail: z.string().optional(),
});
export const ValidationResultSchema = z.object({
    score: z.number().min(0).max(1),
    warnings: z.array(ValidationWarningSchema).default([]),
});
export const RichResponseMetadataSchema = z.object({
    strongsRefs: z.array(StrongsRefSchema).default([]),
    notableStrongs: z.array(NotableStrongsRefSchema).default([]),
    verseRefs: z.array(VerseRefSchema).default([]),
    crossRefs: z.array(CrossRefSchema).default([]),
    primaryVerse: VerseRefSchema.optional(),
    validation: ValidationResultSchema.optional(),
});
//# sourceMappingURL=rich-response.js.map